import React from 'react';
import ContentLoader from 'react-content-loader';
import { useLocalStorage } from 'react-use';

const CommentLoader = (props) => {
  const DarkMode = useLocalStorage('darkMode');
  return (
    <ContentLoader
      speed={1}
      viewBox='0 0 850 320'
      backgroundColor={DarkMode[0] ? '#3c3c3c' : '#eaeced'}
      foregroundColor={DarkMode[0] ? '#252525' : '#ffffff'}
      {...props}
    >
      <circle cx='45' cy='50' r='45' />
      <circle cx='45' cy='150' r='45' />
      <circle cx='45' cy='250' r='45' />

      <rect x='100' y='30' rx='5' ry='5' width='720' height='15' />
      <rect x='100' y='50' rx='5' ry='5' width='90' height='15' />
      <rect x='200' y='50' rx='5' ry='5' width='110' height='15' />
      <rect x='320' y='50' rx='5' ry='5' width='90' height='15' />
      <rect x='420' y='50' rx='5' ry='5' width='80' height='15' />
      <rect x='510' y='50' rx='5' ry='5' width='70' height='15' />
      <rect x='590' y='50' rx='5' ry='5' width='90' height='15' />

      <rect x='100' y='130' rx='5' ry='5' width='720' height='15' />
      <rect x='100' y='150' rx='5' ry='5' width='90' height='15' />
      <rect x='200' y='150' rx='5' ry='5' width='110' height='15' />
      <rect x='320' y='150' rx='5' ry='5' width='90' height='15' />
      <rect x='420' y='150' rx='5' ry='5' width='80' height='15' />
      <rect x='510' y='150' rx='5' ry='5' width='70' height='15' />
      <rect x='590' y='150' rx='5' ry='5' width='90' height='15' />

      <rect x='100' y='230' rx='5' ry='5' width='720' height='15' />
      <rect x='100' y='250' rx='5' ry='5' width='90' height='15' />
      <rect x='200' y='250' rx='5' ry='5' width='110' height='15' />
      <rect x='320' y='250' rx='5' ry='5' width='90' height='15' />
      <rect x='420' y='250' rx='5' ry='5' width='80' height='15' />
      <rect x='510' y='250' rx='5' ry='5' width='70' height='15' />
      <rect x='590' y='250' rx='5' ry='5' width='90' height='15' />
    </ContentLoader>
  );
};

export default CommentLoader;
